// For convenient work with permissions
// It's a copy from backend PermissionNames

export const USER_CRUD = 'USER_CRUD'

export const FILE_CRUD = 'FILE_CRUD'
export const MAP_REQUEST_CRUD = 'MAP_REQUEST_CRUD'

export const BUILDING_READ = 'BUILDING_READ'
export const BUILDING_CREATE = 'BUILDING_CREATE'
export const BUILDING_UPDATE = 'BUILDING_UPDATE'
export const BUILDING_DELETE = 'BUILDING_DELETE'

export const DEPARTMENT_READ = 'DEPARTMENT_READ'
export const DEPARTMENT_CREATE = 'DEPARTMENT_CREATE'
export const DEPARTMENT_UPDATE = 'DEPARTMENT_UPDATE'
export const DEPARTMENT_DELETE = 'DEPARTMENT_DELETE'

export const EMPLOYEE_READ = 'EMPLOYEE_READ'
export const EMPLOYEE_CREATE = 'EMPLOYEE_CREATE'
export const EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE'
export const EMPLOYEE_DELETE = 'EMPLOYEE_DELETE'

export const EMPLOYEE_POSITION_READ = 'EMPLOYEE_POSITION_READ'
export const EMPLOYEE_POSITION_CREATE = 'EMPLOYEE_POSITION_CREATE'
export const EMPLOYEE_POSITION_UPDATE = 'EMPLOYEE_POSITION_UPDATE'
export const EMPLOYEE_POSITION_DELETE = 'EMPLOYEE_POSITION_DELETE'

export const FLOOR_READ = 'FLOOR_READ'
export const FLOOR_CREATE = 'FLOOR_CREATE'
export const FLOOR_UPDATE = 'FLOOR_UPDATE'
export const FLOOR_DELETE = 'FLOOR_DELETE'

export const POINT_READ = 'POINT_READ'
export const POINT_CREATE = 'POINT_CREATE'
export const POINT_UPDATE = 'POINT_UPDATE'
export const POINT_DELETE = 'POINT_DELETE'

export const ROOM_READ = 'ROOM_READ'
export const ROOM_CREATE = 'ROOM_CREATE'
export const ROOM_UPDATE = 'ROOM_UPDATE'
export const ROOM_DELETE = 'ROOM_DELETE'

export const PRINTER_READ = 'PRINTER_READ'
export const PRINTER_CREATE = 'PRINTER_CREATE'
export const PRINTER_UPDATE = 'PRINTER_UPDATE'
export const PRINTER_DELETE = 'PRINTER_DELETE'

export const DESK_READ = 'DESK_READ'
export const DESK_CREATE = 'DESK_CREATE'
export const DESK_UPDATE = 'DESK_UPDATE'
export const DESK_DELETE = 'DESK_DELETE'

export const DESK_EVENT_READ = 'DESK_EVENT_READ'
export const DESK_EVENT_CREATE = 'DESK_EVENT_CREATE'
export const DESK_EVENT_CREATE_INFINITY = 'DESK_EVENT_CREATE_INFINITY'
export const DESK_EVENT_UPDATE = 'DESK_EVENT_UPDATE'
export const DESK_EVENT_DELETE = 'DESK_EVENT_DELETE'
export const DESK_EVENT_BOOK_FOR_OTHERS = 'DESK_EVENT_BOOK_FOR_OTHERS'

export const PC_READ = 'PC_READ'
export const PC_CREATE = 'PC_CREATE'
export const PC_UPDATE = 'PC_UPDATE'
export const PC_DELETE = 'PC_DELETE'

export const PERMISSION_CRUD = 'PERMISSION_CRUD'
export const SETTINGS_CRUD = 'SETTINGS_CRUD'
